export default __webpack_public_path__ + "static/media/screen-reader.48587085.svg";